import * as React from 'react';
import { Card, Header, Segment } from 'semantic-ui-react';
import { ActionMenu } from '~/InfoCard/ActionMenu';
import { InfoCard } from '~/InfoCard/InfoCard';
import { InfiniteScroll, Placeholder } from '~/UI';
var Page = React.memo(function (_a) {
    var InfoCardLink = _a.InfoCardLink, infoCards = _a.infoCards, InfoCardsLink = _a.InfoCardsLink, onBlacklisted = _a.onBlacklisted;
    return (<>
		{infoCards.map(function (infoCard) { return (<InfoCard infoCard={infoCard} InfoCardLink={InfoCardLink} InfoCardsLink={InfoCardsLink} key={infoCard.id} menu={<ActionMenu infoCard={infoCard} onBlacklisted={onBlacklisted}/>}/>); })}
	</>);
});
export var Grid = function (_a) {
    var InfoCardLink = _a.InfoCardLink, InfoCardsLink = _a.InfoCardsLink, results = _a.results, onLoad = _a.onLoad, onReload = _a.onReload;
    if (results.isLoading && results.value === null) {
        return <Placeholder />;
    }
    if (results.value === null) {
        return null;
    }
    if (results.value[0].pagination.total === 0) {
        return (<Segment placeholder>
				<Header icon>Nenalazena žádná aktualita</Header>
			</Segment>);
    }
    return (<InfiniteScroll marginTop='2rem' onLoad={onLoad}>
			<Card.Group doubling stackable data-testid='infocards' itemsPerRow={3}>
				{results.value.map(function (infoCards, index) { return (<Page InfoCardLink={InfoCardLink} infoCards={infoCards.items} InfoCardsLink={InfoCardsLink} key={index} onBlacklisted={onReload}/>); })}
			</Card.Group>
		</InfiniteScroll>);
};
